import homeapi from '../apis/home'
import loveboxApi from '../apis/lovebox'

const state = {
  bannerList: [],
  commonwealList: [],
  cabinetGiftList: [],
  giftsList: [],
  messageList: [],
  giftTotal: 0,
  showAnnualReport: false,
  annualStep: 0,
  loveboxList: [],
  loginWelcomeVisible: false,
  loginDays: 0,
  inviteDlgVisible: false,
  flashGifts: [],
  brandGifts: [],
  homeLoading: false,
  // 首頁九宮格節慶檔期，由 server 提供（app/configs/homeFestivals）
  // null 表示還沒拿到，空陣列表示 server 說目前沒有節慶
  festivals: null
}

const mutations = {
  setHomeBanner (state, {bannerList}) {
    if (!bannerList) {
      return
    }
    state.bannerList = bannerList.map(item => {
      if (item.text) {
        return {
          url: item.url || 'javascript:',
          img: item.image,
          title: item.text || null
        }
      }
      return {
        url: item.url || 'javascript:',
        img: item.image
      }
    })
  },
  setCommonweal (state, {commonwealList}) {
    if (commonwealList) {
      state.commonwealList = commonwealList.data.slice(0, 4)
    }
  },
  setTraceGift (state, {data}) {
    state.giftsList.find(item => item.gift_id === data.id).is_tracing = data.is_tracing
    state.giftsList = [...state.giftsList]
  },
  setHomeData (state, res) {
    state.messageList = res.repeating
    state.cabinetGiftList = res.box_gifts
    state.giftsList = res.mixed_gifts
    state.giftTotal = res.gift_left
  },
  setHomeLovebox (state, { data }) {
    state.loveboxList = data
  },
  showLoginWelcome (state, { visible, days = 0 }) {
    state.loginWelcomeVisible = visible
    state.loginDays = days
  },
  showInviteDialog (state, { visible }) {
    state.inviteDlgVisible = visible
  },
  setAppData (state, res) {
    state.messageList = res.repeating
    state.giftsList = res.gifts
    state.flashGifts = res.flashes
    state.brandGifts = res.brands || []
    state.loveboxList = res.loveboxes
    state.commonwealList = res.needs
    state.giftTotal = res.gift_left
    // 舊版 server 沒有 festivals 欄位時維持 null，讓元件用預設檔期
    if (res.festivals) {
      state.festivals = res.festivals
    }
    state.homeLoading = false
  },
  setHomeLoading (state, loading) {
    state.homeLoading = loading
  }
}

const actions = {
  getHomeBanner ({commit}) {
    return homeapi.getBanner()
      .then(bannerList => commit('setHomeBanner', { bannerList }))
  },
  getHomeCommonweal ({commit}) {
    return homeapi.getCommonweal()
      .then(commonwealList => commit('setCommonweal', { commonwealList }))
  },
  toggleTraceGift ({commit}, {giftId, isTraced}) {
    return homeapi.toggleTraceGift(giftId, isTraced)
      .then(data => {
        commit('setTraceGift', { data })
      })
  },
  getHomeData ({commit, state}) {
    return homeapi.getHomeData()
      .then((res) => {
        commit('setHomeData', res)
      })
  },
  getHomeLovebox ({ commit }) {
    return loveboxApi.getLovebox('ongoing', 'random', '', 1, 3)
      .then(data => {
        commit('setHomeLovebox', data)
      })
      .catch((error) => { console.log(error) })
  },
  getAppData ({ commit, state }) {
    commit('setHomeLoading', true)
    return homeapi.getAppData()
      .then((res) => {
        commit('setAppData', res)
      })
  }
}

export default {
  state,
  mutations,
  actions
}
